<form [formGroup]="formGroup" class="mt-2">
  <coso-wizard
    #wizard
    linear
    [stepIcons]="stepIcons"
    [nextDisabled]="nextButtonDisabled"
    [prevDisabled]="prevButtonDisabled"
    (nextButtonClicked)="onNextButtonClick($event)"
    (prevButtonClicked)="onPreviousButtonClick($event)"
    (wizardFinished)="onWizardFinished()"
  >
    <cdk-step
      [completed]="(isSaaS && formGroup.controls.configuration.valid) || (isSaaS === false && formGroup.controls.configuration.valid && isSaveSuccessful)"
      [stepControl]="formGroup.controls.configuration"
      label="Configuration Wizard"
      aria-label="Step 1: Starting the Configuration Wizard"
    >
      <h1 class="wizard-title">Configuration Wizard</h1>
      <p>Welcome to {{ productName }} configuration wizard.</p>
      <p>Once the configuration wizard is complete, you're ready to start the replication process!</p>
      <p>{{ isSaaS ? "Specify a name for your configuration:" : "Specify a name and, optionally, a description for your configuration:" }}</p>
      <p class="text-muted">
        <small><em>All fields are required unless specified optional</em></small>
      </p>
      <input type="hidden" [formControl]="formGroup.controls.configuration.controls.id" />
      <coso-text-input [control]="formGroup.controls.configuration.controls.name" [inputText]="configurationFormText.name"></coso-text-input>
      @if (isSaaS === false) {
      <coso-text-input [control]="formGroup.controls.configuration.controls.description" [inputText]="configurationFormText.description"></coso-text-input>
      }
    </cdk-step>
    <cdk-step
      [completed]="formGroup.controls.dynamics365.valid && (dynamics365ConnectionHandler.isTestConnectionSuccessfulFor$(formGroup.controls.dynamics365.value.internalId) | async)"
      [stepControl]="formGroup.controls.dynamics365"
      label="Dynamics 365 configuration"
      aria-label="Step 2: Configuring Dynamics 365 connection"
    >
      <h1 class="wizard-title">Dynamics 365</h1>
      <p class="text-muted">
        <small><em>All fields are required unless specified optional</em></small>
      </p>
      <coso-dynamics-365-connection-form
        [viewMode]="ViewMode.Create"
        [isSaaS]="isSaaS"
        [connectionFormGroup]="formGroup.controls.dynamics365"
        [formText]="d365ConnectionFormText"
        [showAzureEndpoint]="false"
        [showGrantType]="true"
        [supportsManagedIdentity]="!isSaaS"
        [showUseDefaultCertificate]="true"
        [supportsExternalAzureAdAppInSaaS]="true"
      ></coso-dynamics-365-connection-form>
    </cdk-step>
    <cdk-step
      [completed]="formGroup.controls.sharePoint.valid && (sharePointConnectionHandler.isTestConnectionSuccessfulFor$(formGroup.controls.sharePoint.value.internalId) | async) && isSaveSuccessful"
      [stepControl]="formGroup.controls.sharePoint"
      label="SharePoint configuration"
      aria-label="Step 3: Configuring SharePoint connection"
    >
      <h1 class="wizard-title">SharePoint</h1>
      <p class="text-muted">
        <small><em>All fields are required unless specified optional</em></small>
      </p>
      <coso-sharepoint-connection-form
        [viewMode]="ViewMode.Create"
        [isSaaS]="isSaaS"
        [connectionFormGroup]="formGroup.controls.sharePoint"
        [showAzureEndpoint]="false"
        [showIsOnlineOption]="false"
        [showGrantType]="true"
        [supportsManagedIdentity]="!isSaaS"
        [showUseDefaultCertificate]="true"
        [supportsExternalAzureAdAppInSaaS]="true"
        [showApiPermission]="true"
      ></coso-sharepoint-connection-form>
    </cdk-step>
    @if (isSaaS === true) {
    <cdk-step [completed]="isActivationStepCompleted" label="Token Activation" aria-label="Step 4: Activating your service">
      <h1 class="wizard-title">Token Activation</h1>
      <coso-token-activation-step
        [token]="token"
        [configurationId]="instanceId"
        [productPricingUrl]="productShopUrl"
        (completed)="isActivationStepCompleted = $event"
        (skipped)="activationSkipped = $event"
      ></coso-token-activation-step>
    </cdk-step>
    }
    <cdk-step [completed]="true" label="Finish" [aria-label]="isSaaS ? 'Step 5: ' : 'Step 4: ' + 'Finishing the Configuration Wizard'">
      <h1 class="wizard-title">{{ activationSkipped ? "Congratulations!" : "Start Replication!" }}</h1>
      <coso-finish-step
        [productName]="productName"
        [activationSkipped]="activationSkipped"
        [productShopUrl]="productShopUrl"
        [startControl]="formGroup.controls.startReplication"
        startWhat="replicating"
      >
      </coso-finish-step>
    </cdk-step>
  </coso-wizard>
</form>

<ng-template #organizationUrlPopover>
  <p>The URL of your Dynamics 365 instance.</p>
  Examples:
  <ul>
    <li>https://OrganizationName.api.crm4.dynamics.com/</li>
    <li>https://CrmName.contoso.com/OrganizationName/</li>
  </ul>
</ng-template>
